import { useEffect, useState } from "react";
import { DATA_TYPE, DATA_TYPE_HANDLER, DUMMY_DATA, HTTP_REQUEST_TYPE, LOCALSTORAGE_KEYS, SORTING_NAME, SIDEBAR_DATA, INTEL_CLOUDINARY_BASE_URL } from "../../utils/enum";
import classes from "./api-integration.module.scss";
import Accordion from "react-bootstrap/Accordion";
import { getApiConsumption, getApiDetails, getAPIexplorerAutoSuggest, submitApiRequest } from "../../service/axios/api-integration";
import { toast } from "react-toastify";
import Input from "../common/input/input";
import DynamicDropdown from "../common/dropdown/dynamic-dropdown";
import SingleDropdown from "../common/dropdown/single-dropdown";
import ResponseBody from "./responseBody";
import { changeDataValueHandler, cleanRequestBodyHandler, dataCoverter, dateFormatHandler, useCopyToClipboard, useQuery } from "../../utils/hooks";
import CodeMirror from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { clearLocalStorage, getLocalStorageItemHandler } from "../../service/local-storage";
import { fetchToCurl } from "fetch-to-curl";
import { useNavigate } from "react-router-dom";
import Header from "../header/header";
import Spinner from "react-bootstrap/Spinner";
import Counter from "../common/counter/counter";
import ApiConsumption from "./api-consumption";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import DatePicker from "../common/datePicker/datePicker";
import { GTM_ENUM } from "../../utils/gtm_enum";
import AutoSuggest from "../common/AutoSuggest/autoSuggest";
import { captureException } from "@sentry/browser";
import CustomDropdown from "../common/dropdown/custom-dropdown";

const extensions = [javascript({ jsx: true, indentUnit: 0 })];
const { USER_DATA } = LOCALSTORAGE_KEYS;
const { getintouchBtnCreditsAPIex, submitRequestBtnAPIex } = GTM_ENUM;
let timer = null;

const ApiIntegrationComponent = () => {
  const [data, setData] = useState(DUMMY_DATA);
  const [selectedApiIndex, setSelectedApiIndex] = useState(null);
  const [apiData, setApiData] = useState({});
  const [sortedData, setSortedData] = useState([]);
  const [requestObj, setRequestObj] = useState({});
  const [responseData, setReponseData] = useState(null);
  const [creditPercentage, setCeditPercentage] = useState(0);
  const [credits, setCredits] = useState({});
  const [curl, setCurl] = useState(null);
  const [status, setStatus] = useState("200");
  const [isCopied, setIsCopied] = useState(false);
  const [value, copy] = useCopyToClipboard();
  const [email, setEmail] = useState("");
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [isLive, setIsLive] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [width, setWidth] = useState("0px");
  const [show, setShow] = useState(false);
  const [consumedData, setConsumedData] = useState([]);
  const [defaultKey, setDefaultKey] = useState(null);
  const navigate = useNavigate;
  let query = useQuery("defaultKeyType");
  const http_request_pill_class = apiData?.type?.toString()?.toLowerCase() ? HTTP_REQUEST_TYPE[apiData.type.toString().toLowerCase()] : HTTP_REQUEST_TYPE.get;
  const token = getLocalStorageItemHandler(USER_DATA);

  useEffect(() => {
    setIsLoaderActive(true);
    getApiDetails()
      .then(({ data }) => {
        for (let i = 0; i < data.data.length; i++) {
          if (SIDEBAR_DATA().hasOwnProperty(data.data[i].api_product_name)) {
            data.data[i].sub_data = [...data.data[i].sub_data, ...SIDEBAR_DATA(btoa(token?.email))[data.data[i].api_product_name]];
          }
        }
        setData(data);
        let percentage = Math.ceil((data.current_credits / data.maximum_credits) * 100);
        setCredits({
          current_credits: data.current_credits,
          maximum_credits: data.maximum_credits,
          show_details: data.show_details ? true : false,
        });
        setCeditPercentage(percentage);
      })
      .catch((err) => {
        if (err.response.status.toString() === "401") {
          clearLocalStorage();
          timer = setTimeout(() => {
            window.location.href = "/login" + window.location.search;
          }, 100);
        }
      })
      .finally(() => {
        setIsLoaderActive(false);
      });
  }, []);

  useEffect(() => {
    if (data) {
      let apiData = [...data.data];
      if (query) {
        setSelectedApiIndex(query);
      }
      let index = null;
      let innerIndex = null;
      if (apiData?.length) {
        for (let i = 0; i < apiData.length; i++) {
          for (let j = 0; j < apiData[i]?.sub_data?.length; j++) {
            if (apiData[i]?.sub_data[j]?.api_name?.toLowerCase().trim() === query?.toLowerCase().trim()) {
              index = i;
              innerIndex = j;
              break;
            }
          }
          if (index === 0 || index) {
            break;
          }
        }
      }
      if (index === null && apiData?.[0]?.sub_data?.[0]) {
        let defaultSelected = apiData[0].sub_data[0];
        setSelectedApiIndex(defaultSelected?.api_name);
        setApiData(defaultSelected);
        setDefaultKey("0");
      } else {
        let defaultSelected = apiData[index].sub_data[innerIndex];
        setSelectedApiIndex(defaultSelected?.api_name);
        setApiData(defaultSelected);
        setDefaultKey(index);
      }
    }
  }, [data, query]);

  useEffect(() => {
    if (!token || !Object.keys(token)?.length) {
      setTimeout(() => {
        window.location.href = "/login" + window.location.search;
      }, 100);
    }
  }, [token]);

  useEffect(() => {
    let totalFieldsArray = [];
    makeRequestFormHandler(apiData?.request_params, totalFieldsArray);
    totalFieldsArray = totalFieldsArray.map((dataField) => ({
      ...dataField,
      value: dataField?.default_value ? dataField?.default_value : dataField?.multiplier ? dataField?.multiplier : dataField?.value,
    }));
    let requiredField = totalFieldsArray.filter((dataField) => dataField.required);
    let notRequiredField = totalFieldsArray.filter((dataField) => !dataField.required);

    setSortedData([...requiredField, ...notRequiredField]);
    setRequestObj(apiData?.sample_request);
    setReponseData(apiData?.sample_response);
    genrateCurlHandler(apiData?.sample_request);
  }, [apiData]);

  useEffect(() => {
    return () => clearTimeout(timer);
  }, []);

  //  to update credits on screen
  const updateCreditsHandler = () => {
    getApiDetails()
      .then(({ data }) => {
        // setData(data)
        let percentage = Math.ceil((data.current_credits / data.maximum_credits) * 100);
        setCredits({
          current_credits: data.current_credits,
          maximum_credits: data.maximum_credits,
        });
        setCeditPercentage(percentage);
      })
      .catch((err) => {
        toast.error(err.message);
        captureException(err);
      });
  };

  // update credits on usage call
  const dataConsumptionApi = () => {
    getApiConsumption()
      .then(({ data }) => setConsumedData(data))
      .catch((err) => {
        captureException(err);
      });
  };

  // change the simple response to desired reponse
  const makeRequestFormHandler = (value, array) => {
    let data = value ? JSON.parse(JSON.stringify(value)) : {};
    for (let property in data) {
      let obj = {};
      if (data[property].type === "object") {
        objectHandler(data[property].properties, array, property, data[property]);
      } else {
        if (data[property].type === "array" && !data[property]?.items?.hasOwnProperty("properties")) {
          obj.type = data[property]?.type;
          obj.title = property;
          obj.key = property;
          obj.type = data[property]?.items?.type;
          if (data[property]?.hasOwnProperty("default_selection") && Array.isArray(data[property]["default_selection"])) {
            obj.value = data[property]["default_selection"].map((sancList) => ({ label: sancList, value: sancList }));
          } else if (data[property]?.hasOwnProperty("default_selection")) {
            obj.value = { label: data[property]["default_selection"], value: data[property]["default_selection"] };
          }
          obj = { ...obj, ...data[property] };
          array.push(obj);
        } else if (data[property].type !== "array") {
          obj.type = data[property]?.type;
          obj.title = property;
          obj.key = property;
          obj = { ...obj, ...data[property] };
          if (data[property]?.hasOwnProperty("default_selection")) {
            obj.value = { label: data[property]["default_selection"], value: data[property]["default_selection"] };
          }
          array.push(obj);
        } else {
          arrayHandler(data[property].items, array, property);
        }
      }
    }
  };

  // to loop through the object and get the desired properties
  const objectHandler = (val, array, property, data) => {
    let obj = {};
    obj.type = property;
    obj.label = property;
    obj = { ...obj, ...data };
    obj.title = property;
    let newArray = [];
    for (let value in val) {
      if (val[value]?.hasOwnProperty("default_selection")) {
        obj.value = { label: val[value]["default_selection"], value: val[value]["default_selection"] };
      }
      newArray.push({ ...val[value], title: value, label: value, placeholder: value });
    }
    obj.properties = newArray;
    array.push(obj);
  };

  // to loop through the array and get the desired properties
  const arrayHandler = (val, array, property) => {
    for (let value in val.properties) {
      let obj = {};
      obj.property = property;
      obj.type = val?.properties?.[value]?.type;
      obj.title = value;
      obj.key = value;
      obj.innerType = val?.properties?.[value]?.type;
      if (val[value]?.hasOwnProperty("default_selection")) {
        obj.value = { label: val[value]["default_selection"], value: val[value]["default_selection"] };
      }
      array.push(obj);
    }
  };

  // get all the value from input onchange all input values cme this function
  const onChangeHandler = (value, parent, index, parentData) => {
    let requestObject = JSON.parse(JSON.stringify(requestObj));
    let sortedDataClone = JSON.parse(JSON.stringify(sortedData));
    if (parentData?.properties) {
      requestObject[parentData.title][parent.title] = Array.isArray(value)
        ? value.map((item) => item.value)
        : typeof value === DATA_TYPE.object && parent.type !== DATA_TYPE.date
          ? dataCoverter(parent, value?.value)
          : dataCoverter(parent, value);
    } else {
      if (parentData) {
        requestObject[parentData.title][parent.title] =
          parent?.hasOwnProperty("auto_suggest_url") && parent.type === DATA_TYPE.string
            ? value?.[0]?.label || ""
            : Array.isArray(value)
              ? value.map((item) => item.value || item.label)
              : typeof value === DATA_TYPE.object && parent.type !== DATA_TYPE.date
                ? dataCoverter(parent, value?.value)
                : dataCoverter(parent, value);
      } else {
        requestObject[parent.title] =
          parent?.hasOwnProperty("auto_suggest_url") && parent.type === DATA_TYPE.string
            ? value?.[0]?.label || ""
            : Array.isArray(value)
              ? value.map((item) => item.value || item.label)
              : typeof value === DATA_TYPE.object && parent.type !== DATA_TYPE.date
                ? dataCoverter(parent, value?.value)
                : dataCoverter(parent, value);
      }
    }
    if (sortedDataClone[index]) {
      if (sortedDataClone[index]?.properties) {
        let i = sortedDataClone[index]?.properties?.findIndex((item) => item.title === parent.title);
        if (i > -1) {
          sortedDataClone[index].properties[i].value = Array.isArray(value)
            ? value
            : typeof value === DATA_TYPE.object || parent.type === DATA_TYPE.date
              ? value
              : dataCoverter(parent, value);
        }
      } else {
        sortedDataClone[index].value = Array.isArray(value) ? value : typeof value === DATA_TYPE.object || parent.type === DATA_TYPE.date ? value : dataCoverter(parent, value);
      }
    }
    let requiredData = sortedDataClone.filter((item) => item.required);
    let isRequired = true;
    for (let i = 0; i < requiredData.length; i++) {
      let valid_value =
        requiredData[i]?.type === DATA_TYPE.string
          ? requiredData[i]?.value?.value
            ? requiredData[i]?.value?.value
            : requiredData[i]?.value?.toString()?.trim()
          : requiredData[i]?.value;
      if (valid_value) {
        isRequired = false;
      } else {
        isRequired = true;
        break;
      }
    }
    if (!requiredData.length) {
      let optionalWith = sortedDataClone.filter((item) => item?.optionalWith);
      if (optionalWith && optionalWith.length) {
        for (let i = 0; i < optionalWith.length; i++) {
          let valid_value =
            optionalWith[i]?.type === DATA_TYPE.string
              ? optionalWith[i]?.value?.value
                ? optionalWith[i]?.value?.value
                : optionalWith[i]?.value?.toString()?.trim()
              : optionalWith[i]?.value;
          if (valid_value) {
            isRequired = false;
          } else {
            let filterOptionalWith = sortedDataClone.filter((item) => item?.key === optionalWith[i].optionalWith);
            let validvalue =
              filterOptionalWith[i]?.type === DATA_TYPE.string
                ? filterOptionalWith[i]?.value?.value
                  ? filterOptionalWith[i]?.value?.value
                  : filterOptionalWith[i]?.value?.toString()?.trim()
                : filterOptionalWith[i]?.value;
            if (validvalue) {
              isRequired = false;
            } else {
              isRequired = true;
              break;
            }
          }
        }
      }
    }
    if (parent.childField) {
      for (let i = 0; i < sortedDataClone.length; i++) {
        if (sortedDataClone[i].key === parent.childField) {
          sortedDataClone[i].value = [];
        }
      }
    }
    setIsDisabled(isRequired);
    setSortedData(sortedDataClone);
    setRequestObj(requestObject);
    let newRequestObject = cleanRequestBodyHandler(requestObject);
    genrateCurlHandler(newRequestObject);
  };

  // to submit api call
  const submitRequestHandler = () => {
    setLoader(true);
    setReponseData(null);
    setIsLive(true);
    let url = apiData?.api_endpoint.replace("{base_url}", "");
    let newRequestObject = cleanRequestBodyHandler(requestObj, apiData?.sample_request);
    changeDataValueHandler(newRequestObject);
    submitApiRequest(apiData?.product_type, url, newRequestObject)
      .then((res) => {
        setReponseData(res.data);
        let el = document.getElementById("searcheddataElement");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
          setStatus("200");
          updateCreditsHandler();
          setLoader(false);
        }
      })
      .catch((err) => {
        setReponseData(err.response.data);
        setStatus(err.response.status.toString());
        setLoader(false);
        captureException(err);
      });
  };

  // to generate curl for the input field
  const genrateCurlHandler = (requestObj) => {
    const baseUrl = apiData?.api_endpoint;
    const token = getLocalStorageItemHandler(USER_DATA);
    let emailEncrypt = btoa(token?.email);
    setEmail(emailEncrypt);

    if (token?.ssoToken) {
      const options = {
        headers: {
          ssoToken: token.ssoToken,
          sessionId: token.session_id,
          "Content-Type": "application/json",
        },
        method: apiData?.type,
        body: JSON.stringify(requestObj),
      };
      setCurl(fetchToCurl(baseUrl, options));
    }
  };

  const handleSearch = (value, inpFieldObj, index) => {
    let sortedDataClone = JSON.parse(JSON.stringify(sortedData));
    sortedDataClone[index].loading = true;
    let url = inpFieldObj.auto_suggest_url.split(`${inpFieldObj.auto_suggest_field_name}=`).join(`${inpFieldObj.auto_suggest_field_name}=${value}`);
    getAPIexplorerAutoSuggest(url)
      .then(({ data }) => {
        let option = data[Object.keys(data)[0]].map((item) => {
          if (typeof item === DATA_TYPE.object) {
            return { label: item.label, value: item.label };
          } else {
            return { label: item, value: item };
          }
        });
        sortedDataClone[index].options = option;
        sortedDataClone[index].loading = false;
        sortedDataClone[index].value = value ? [{ value, label: value }] : [];
        setSortedData(sortedDataClone);
      })
      .catch((err) => {
        sortedDataClone[index].loading = false;
        setSortedData(sortedDataClone);
        captureException(err);
      });
  };

  // to handle all the input type dropdown,counter,input
  const inputTypeHander = (item, index, value) => {
    const { object } = DATA_TYPE;
    if (item?.multiplier) {
      return (
        <Counter value={item.value} onChangeHandler={onChangeHandler} parentData={value ? value : null} index={index} item={item} placeholder={item.title} name={item.title} />
      );
    } else if (item.hasOwnProperty("auto_suggest_url")) {
      return (
        <AutoSuggest
          handleSearch={handleSearch}
          item={item}
          index={index}
          options={item?.options?.length ? item.options : []}
          onChangeHandler={onChangeHandler}
          parentData={value ? value : null}
          placeholder={item.title}
          name={item.title}
        />
      );
    } else if (item?.valid_values || item?.valid_values_dict) {
      let options = [];
      if (item?.valid_values && Object.keys(item?.valid_values?.[0]).length && typeof item?.valid_values?.[0] === object) options = JSON.parse(JSON.stringify(item?.valid_values));
      else if (item?.valid_values) options = item?.valid_values?.map((item) => ({ label: SORTING_NAME[item] ? SORTING_NAME[item] : item, value: item }));
      else if (item?.valid_values_dict) {
        let field = sortedData.find((val) => val.title === item.dependent_field)?.value?.value;
        if (!field) {
          field = sortedData.find((val) => val.title === item.dependent_field)?.value;
        }
        if (typeof field === "string" && item?.valid_values_dict[field]) {
          options = [...(item?.valid_values_dict?.[field] || [])];
        } else if (Array.isArray(field) && item?.valid_values_dict) {
          options = [];
          for (let i = 0; i < field.length; i++) {
            options = [...options, ...(item?.valid_values_dict?.[field[i].value] || [])];
          }
        }
      }
      if (item?.type === DATA_TYPE.string || item?.type === DATA_TYPE.number || item?.type === DATA_TYPE.boolean) {
        return (
          <SingleDropdown
            value={item.value}
            options={options}
            onChangeHandler={onChangeHandler}
            parentData={value ? value : null}
            index={index}
            item={item}
            placeholder={item.title}
            name={item.title}
          />
        );
      }
      return (
        <CustomDropdown
          closeInputHandler={closeInputHandler}
          openInputHandler={openInputHandler}
          value={item.value}
          options={options}
          onChangeHandler={onChangeHandler}
          parentData={value ? value : null}
          index={index}
          item={item}
          placeholder={item.title}
          name={item.title}
        />
      );
    } else if (item?.type === DATA_TYPE.date) {
      return (
        <DatePicker value={item.value} onChangeHandler={onChangeHandler} parentData={value ? value : null} index={index} item={item} placeholder={item.title} name={item.title} />
      );
    } else if (item?.type === DATA_TYPE.array) {
      return (
        <DynamicDropdown
          value={item.value}
          onChangeHandler={onChangeHandler}
          parentData={value ? value : null}
          index={index}
          item={item}
          placeholder={item.title}
          name={item.title}
        />
      );
    } else {
      return (
        <Input
          value={item.value}
          onChangeHandler={onChangeHandler}
          parentData={value ? value : null}
          index={index}
          item={item}
          placeholder={item.title}
          name={value ? value.title : item.title}
        />
      );
    }
  };

  const openInputHandler = (item, index) => {
    let sortedDataClone = JSON.parse(JSON.stringify(sortedData));
    if (sortedDataClone[index].hasOwnProperty("isOpen")) {
      sortedDataClone[index].isOpen = !sortedDataClone[index].isOpen;
    } else {
      sortedDataClone[index].isOpen = true;
    }
    setSortedData(sortedDataClone);
  };

  const closeInputHandler = (item, index) => {
    let sortedDataClone = JSON.parse(JSON.stringify(sortedData));
    if (sortedDataClone[index].hasOwnProperty("isOpen")) {
      sortedDataClone[index].isOpen = false;
    } else {
      sortedDataClone[index].isOpen = false;
    }
    setSortedData(sortedDataClone);
  };

  // set classes for different different status
  const statusResultHandler = () => {
    if (status.includes(4)) {
      return "staus_code_indicator_400";
    } else if (status.includes(3)) {
      return "staus_code_indicator_300";
    } else {
      return "staus_code_indicator_200";
    }
  };

  return (defaultKey || defaultKey === 0) && isLoaderActive === false ? (
    <div className={`${apiData.isStatic ? classes.explorer_page : ""}`}>
      <Header apiData={apiData} />
      <div className="row">
        <div className="col-3">
          <div className={`${classes.left_API_container} ${apiData?.isStatic ? "overflow-auto" : ""}`}>
            <div className={`${classes.api_details_container}`}>
              <Accordion defaultActiveKey={defaultKey.toString()}>
                {data?.data?.map((item, outerIndex) => (
                  <Accordion.Item className={classes.custom_accordion_item} key={outerIndex} eventKey={outerIndex.toString()}>
                    <Accordion.Header>{item.api_product_name}</Accordion.Header>
                    <Accordion.Body className={classes.custom_accordion_body}>
                      {item.sub_data.map((val) => (
                        <div
                          key={val.api_name}
                          onClick={() => {
                            setSelectedApiIndex(val.api_name);
                            setApiData(val);
                            setIsLive(false);
                            setStatus("200");
                            setLoader(false);
                            setIsDisabled(true);
                            window.scroll(0, 0);
                          }}
                          className={`${selectedApiIndex?.toLowerCase()?.trim() === val?.api_name?.toLowerCase()?.trim() ? classes.selected_api_name : classes.unselected_api_name}`}
                        >
                          <div className="d-flex">
                            <p id={val?.ga_events} className={classes.custom_accordion_content}>
                              {val.api_name}
                            </p>
                            {val.isStatic ? (
                              <img
                                className="ps-2 "
                                width={25}
                                src={`${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1698223161/website/API%20Explorer/flash_sign_wbkxcr.svg`}
                                alt="img"
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
            <div className="bottom-0 w-100 my-3">
              <div className={classes.api_credit_container} id="left_panel">
                <div className={classes.api_credit_inner_container}>
                  <CircularProgressbar strokeWidth={10} className={classes.circular_progress_bar} value={creditPercentage} text={`${creditPercentage}%`} />
                  <p className={`${classes.credits_details} mb-1 mt-3`}>
                    <b>
                      You have used {credits.current_credits} credits out of {credits.maximum_credits}
                    </b>
                  </p>
                  <p className="mt-0 mb-1 position-relative">
                    {credits?.show_details ? (
                      <span
                        onClick={() => {
                          dataConsumptionApi();
                          setShow(true);
                        }}
                        className={classes.credit_usage_text}
                      >
                        View Detailed Usage
                      </span>
                    ) : null}
                    <ApiConsumption data={consumedData} show={show} setShow={setShow} width={width} />
                  </p>
                  <p className={`${classes.credits_details} mb-3`}>Leverage our Global Trade and Compliance APIs to seamlessly manage and optimize your business workflows.</p>
                  <button
                    id={getintouchBtnCreditsAPIex}
                    onClick={() => {
                      window.location.href = process.env.REACT_APP_API_WEBSITE_URL + `/get-in-touch?type=Api-trial&session=${email}`;
                    }}
                    className="btn btn-sm primary_fill_button mb-2"
                  >
                    Get in Touch
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-9">
          <div className={`${apiData?.isStatic ? "px-4" : ""} container mt-4`}>
            {apiData?.isStatic ? (
              <div className="static-page d-flex flex-column">
                <div className="page-section d-flex align-items-center">
                  <div className="left-part section d-flex flex-column text-start">
                    <div className="header d-flex">
                      <span className="fs-4">
                        {apiData?.api_name}
                        <img className="ms-1" width={42} src={`${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1698223161/website/API%20Explorer/flash_sign_wbkxcr.svg`} alt="paid" />
                      </span>
                    </div>
                    <p className={`${classes.user_info_text} fs-6`}>{apiData?.api_description}</p>
                    <div className="get-in-touch-section">
                      <button
                        id={getintouchBtnCreditsAPIex}
                        onClick={() => {
                          window.location.href = apiData?.btnLink;
                        }}
                        className="btn btn-sm primary_fill_button mb-2"
                      >
                        Get in Touch
                      </button>
                    </div>
                  </div>
                  <div className="right-part d-flex justify-content-end section">
                    <img className="w-100" alt={apiData?.api_name ? apiData?.api_name : "img"} src={apiData?.imageSrc} />
                  </div>
                </div>
                <div className="page-section d-flex">
                  {apiData.subCategories.map((item) => (
                    <div key={item.title} className="sub-categories section text-start">
                      <div className="category-image w-100 mb-2">
                        <img height={42} alt="img" src={item?.imageSrc} />
                      </div>
                      <div className="category-content w-100">
                        <span className={`${classes.apiHeading} fs-5`}>{item?.title}</span>
                        <p className="fs-6 m-0">{item?.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <div className={`${classes.api_info_text} text-start`}>
                    <span className={classes.apiHeading}>{apiData?.api_name}</span>
                    <p className={classes.user_info_text}>{apiData?.api_description}</p>
                    {apiData?.from_date ? (
                      <p className={classes.user_info_text}>
                        This sample dataset contains trade data from {dateFormatHandler(apiData?.from_date)} to {dateFormatHandler(apiData?.to_date)}. For access to complete data,
                        upgrade to an API subscription.
                      </p>
                    ) : null}
                  </div>
                  {apiData?.credit_rate?.toString()?.[0] !== "0" ? (
                    <span className={classes.credits_rate_text}>
                      Credit Usage : {apiData?.credit} for {apiData?.criteria}
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
                <div className={`${classes.base_api_details_container} mt-4`}>
                  <div className={`${classes.base_api_details} my-2 mx-2`}>
                    <span className={classes[http_request_pill_class]}>{apiData?.type}</span>
                    <span className={classes.api_base_url}>{apiData?.api_endpoint}</span>
                  </div>
                </div>
                <div className={classes.horizontal_role}></div>
                <div className={classes.request_body_container}>
                  <h4 className={classes.request_body_main_heading}>Request Body</h4>
                  <div className={classes.request_body_inner_container}>
                    {sortedData?.map((item, index) => (
                      <div>
                        <div key={index} className="row">
                          <div className="col-6">
                            <div className="d-flex">
                              <span className={classes[DATA_TYPE_HANDLER[item?.type?.toString()]?.class]}>{DATA_TYPE_HANDLER[item.type.toString()].label}</span>
                              <p className={classes.api_basic_heading}>
                                {item?.ghost_text ? item?.ghost_text : item.title}{" "}
                                <span className={classes.api_request_is_required}>
                                  {item.required ? (
                                    <span className="text-error-600">
                                      REQUIRED{" "}
                                      <span>
                                        <sup>*</sup>
                                      </span>
                                    </span>
                                  ) : (
                                    "OPTIONAL"
                                  )}
                                </span>
                              </p>
                            </div>
                            <div>
                              <p className={`${classes.api_basic_description} text-start`}>{item.description}</p>
                            </div>
                          </div>
                          <div className="col-6">
                            {item?.properties?.length ? (
                              <div className="row">
                                {item?.properties?.map((value) => (
                                  <div className={`col-${Math.ceil(12 / item?.properties?.length).toString()}`}>{inputTypeHander(value, index, item)}</div>
                                ))}
                              </div>
                            ) : (
                              inputTypeHander(item, index)
                            )}
                          </div>
                        </div>
                        <div className={`${classes.horizontal_role}`}></div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-4 text-end">
                  <button id={submitRequestBtnAPIex} disabled={isDisabled} onClick={submitRequestHandler} className="btn btn-sm primary_fill_button">
                    Submit Request
                  </button>
                </div>
                <div id="searcheddataElement" className="row mt-5">
                  <div className="col-6">
                    <div className={classes.api_call_details_data_reponse_body}>
                      <div className={`d-flex justify-content-between align-items-center ${classes.api_call_reponse_header}`}>
                        <p className={`m-0 ${classes.api_call_reponse_sub_heading}`}>RESPONSE BODY VARIABLES</p>
                        <div></div>
                      </div>
                      <div className={classes.api_call_reponse_body}>
                        <ResponseBody requestObj={requestObj} sortedData={sortedData} apiData={apiData} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className={classes.api_call_details_data}>
                      <div className={`d-flex justify-content-between align-items-center ${classes.api_call_reponse_header}`}>
                        <p className={`m-0 ${classes.api_call_reponse_sub_heading} d-flex align-items-center`}>
                          <span className="me-2">RESPONSE BODY</span>

                          <div
                            onClick={() => {
                              copy(JSON.stringify(responseData, null, 2));
                              setIsCopied(true);
                              setTimeout(() => {
                                setIsCopied(false);
                              }, 1000);
                            }}
                            className={classes.copy_text_container}
                          >
                            <img
                              alt=""
                              className={classes.copy_img}
                              src={
                                !isCopied
                                  ? `${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1690362826/intel/icons/copy_tw4f0x.svg`
                                  : `${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1690363335/intel/icons/tick1_eh0qgk.svg`
                              }
                            />
                            <p className="my-0 ms-1">{!isCopied ? "Copy" : "Copied"}</p>
                          </div>
                        </p>
                        <div className={classes.copy_text_container}>
                          <div className={classes[statusResultHandler()]}></div>
                          <span>{status}</span>
                          <span className={classes.api_reponse_type}>{isLive ? "Live" : "Example"}</span>
                        </div>
                      </div>
                      <div className={`${classes.api_call_reponse_body}`}>
                        {loader ? (
                          <div>
                            <Spinner animation="border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </Spinner>
                            <p className="mb-0 mt-2">Loading Reponse Body...</p>
                          </div>
                        ) : (
                          <CodeMirror
                            style={{ textAlign: "left", background: "#f8f9fb", maxHeight: "500px" }}
                            value={`${JSON.stringify(responseData || DUMMY_DATA, null, 2)}`}
                            maxHeight="500px"
                            readOnly={true}
                            styleSelectedText={true}
                            extensions={extensions}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5 mb-5">
                  <div className="col-6">
                    <div className={classes.api_call_details_data}>
                      <div className={`d-flex justify-content-between align-items-center ${classes.api_call_reponse_header}`}>
                        <p className={`m-0 ${classes.api_call_reponse_sub_heading}`}>Curl</p>
                        <div
                          onClick={() => {
                            copy(curl);
                            setIsCopied(true);
                            setTimeout(() => {
                              setIsCopied(false);
                            }, 1000);
                          }}
                          className={classes.copy_text_container}
                        >
                          <img
                            alt=""
                            className={classes.copy_img}
                            src={
                              !isCopied
                                ? `${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1690362826/intel/icons/copy_tw4f0x.svg`
                                : `${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1690363335/intel/icons/tick1_eh0qgk.svg`
                            }
                          />
                          <p className="my-0 ms-1">{!isCopied ? "Copy" : "Copied"}</p>
                        </div>
                      </div>
                      <div className={classes.api_call_reponse_body}>
                        <CodeMirror readOnly={true} className="cutsom-code-mirror-class" value={typeof curl === "string" ? curl : ""} mode={{ name: "application/x-sh" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="loader-container">
      <div className="loader-block">
        <img src={"/loader.gif"} alt="description of gif" />
      </div>
    </div>
  );
};

export default ApiIntegrationComponent;
